export function animateNumbers(el) {
	const originalValue = el.textContent;
	const endValue = parseFloat(el.textContent.replace(',', '')); 

	let numberFormatOptions;
	let snappingStep = 1;
	if (Math.abs(endValue) < 5)  {
		snappingStep = .1;
		numberFormatOptions = { minimumFractionDigits: 1 };
	}

	gsap.fromTo(el,
		{ textContent: 0 }, 
		{
			textContent: endValue,
			scrollTrigger: {
				trigger: el,
				start: "center center",
			},
			duration: 1,
			ease: 'circ.out',
			snap: { textContent: snappingStep },
			onUpdate: function () {
				el.textContent = parseFloat(this.targets()[0].textContent).toLocaleString('en-GB', numberFormatOptions)
			},
			onComplete: function() {
				setTimeout(() => {
					el.textContent = originalValue;
				}, 200);
			}
			
		}
	)
}

export function setupSection(section) {
	// console.log(section)
	Array.from(section.querySelectorAll("[data-stat-counter]")).forEach((el, index) => { 
		// console.log("ANIMATING NUMBERS")
		// console.log("EL", el, el.textContent.trim(), el.textContent.trim() == "");
		// if el has empty textContent, skip it
		if (el.textContent.trim() == "") return;
		animateNumbers(el);
	});
}